import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  name: 'staging',
  baseUrl: '/',
  production: false,
  withServiceWorkers: false,
  api: {
    dood: {
      url: 'https://api-staging.dood.com',
    },
    firebase: {
      databaseURL: 'https://dood-dev-1bec4.firebaseio.com',
      authDomain: 'dood-dev-1bec4.firebaseapp.com',
      apiKey: 'AIzaSyBB8NmpEqfw4xkAU9TSFHDX073QMK39UPA',
      projectId: 'dood-dev-1bec4',
      storageBucket: 'dood-dev-1bec4.appspot.com',
      messagingSenderId: '644114158877',
      appId: '1:644114158877:web:490e2c74c768dd221d7df4',
      measurementId: 'G-9GMF66E09H',
    },
    maps: {
      key: 'AIzaSyBovuJRybfwwYXyNfadxLE0D-ns9yQksq8',
    },
    adyen: {
      environment: 'test', // Change to 'live' for the live environment.
      clientKey: 'test_3XIBPXP5R5AH3DUOH72AP6QLUEHDIC4I',
    },
    stripe: {
      key: 'pk_test_51QlvtWIjFup6Lak720fuHT3qqrvlOyg6yEZTloaAczFxAvK7tU0KUsTyRayjpDHz2znWY1jyAe8MOuUyCws4Rhm200eT3CyuHi',
    },
    cmi: {
      url: 'https://testpayment.cmi.co.ma/fim/est3Dgate',
    },
    feeds: {
      url: 'https://api-staging.dood.com',
    },
  },
  native: {
    marketplaceDomain: 'https://staging.dood.com',
  },
};
